import React from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import ClassicImg from "./img/classic.webp";
import ArtImg from "./img/art.webp";
import ClassicImgMobile from "./img/classic-mobile.webp";
import ArtImgMobile from "./img/art-mobile.webp";
import Art2Img from "./img/art2.webp";
import Art2ImgMobile from "./img/art2-mobile.webp";
import {
  setIsArtQrModal,
  setIsClassicQrModal,
} from "../../../../redux/slices/modals";
import {
  qrCornetsInterior,
  qrCornetsOuter,
  qrPattern,
  qrResetSettings,
} from "../../../../redux/slices/qrSettings";
import { qrResetText } from "../../../../redux/slices/qrTextSettings";
import { qrResetFrame } from "../../../../redux/slices/qrFrames";
import { qrOptionsReset } from "../../../../redux/slices/qrOptions";
import useQrConfigs from "../../../../hooks/useQrConfigs";
import { setDesignType } from "../../../../redux/slices/customizeQr";
import { designTypes } from "../../../../constants/common";

function QrMode() {
  const designType = useSelector((state) => state.customizeQr.designType);
  const lang = useSelector(
    (state) => state.changeLang.language.stepThree.qrMode
  );
  const { initialConfigs, currentConfigs, qrSettingsInitialState } =
    useQrConfigs();

  const isSameConfigs =
    JSON.stringify(currentConfigs) === JSON.stringify(initialConfigs);

  const dispatch = useDispatch();

  const handleArtQrSwitch = () => {
    if (isSameConfigs) {
      dispatch(qrResetText());
      dispatch(qrResetSettings());
      dispatch(qrResetFrame());
      dispatch(qrOptionsReset());
      dispatch(setDesignType(designTypes.art));
      dispatch(qrPattern("small-dots"));
      dispatch(qrCornetsOuter("square"));
      dispatch(qrCornetsInterior("square"));
      return;
    }
    dispatch(setIsArtQrModal(true));
  };

  const handleClassicQrSwitch = () => {
    const initialConfigsArtQr = JSON.stringify({
      ...initialConfigs,
      ...{
        ...qrSettingsInitialState,
        pattern: "small-dots",
        cornetsOuter: "square",
        cornetsInterior: "square",
      },
    });

    if (JSON.stringify(currentConfigs) === initialConfigsArtQr) {
      dispatch(qrResetText());
      dispatch(qrResetSettings());
      dispatch(qrResetFrame());
      dispatch(qrOptionsReset());
      dispatch(setDesignType(designTypes.base));
      return;
    }
    dispatch(setIsClassicQrModal(true));
  };

  return (
    <Row className="g-3 mb-3">
      <Col lg={6}>
        <div
          className="p-3 rounded-3 bg-white h-100"
          onClick={handleClassicQrSwitch}
        >
          <Row>
            <Col xs={8} lg={7} className="d-flex gap-2">
              <div style={{ width: 20, height: 20 }}>
                <ClassicQrLabel
                  className={`position-relative border border-1 rounded-circle border-primary d-block${
                    designType === designTypes.art
                      ? " border-border-gray"
                      : " boder-primary checked"
                  }`}
                  style={{ width: 20, height: 20 }}
                />
              </div>
              <div>
                <CardTitle className="fw-bold mb-1">{lang[0]}</CardTitle>
                <div className="text-gray fs-7">{lang[1]}</div>
              </div>
            </Col>

            <Col
              xs={4}
              lg={5}
              className="d-flex justify-content-end align-items-center"
            >
              <img
                src={ClassicImg}
                className="d-none d-lg-block"
                alt="classic-qr"
                loading="lazy"
                width={144}
                height={74}
              />
              <img
                src={ClassicImgMobile}
                className="img-fluid d-lg-none"
                alt="classic-qr"
                loading="lazy"
              />
            </Col>
          </Row>
        </div>
      </Col>
      <Col lg={6}>
        <CustomArtCard
          className="p-3 rounded-3 h-100"
          onClick={handleArtQrSwitch}
        >
          <Row>
            <Col xs={8} lg={7} className="d-flex gap-2">
              <div style={{ width: 20, height: 20 }}>
                <ArtQrLabel
                  className={`position-relative border border-1 rounded-circle border-white d-block${
                    designType === designTypes.art ? " checked" : ""
                  }`}
                  style={{ width: 20, height: 20 }}
                />
              </div>

              <div>
                <div className="d-flex gap-2 align-items-center mb-1">
                  <CardTitle className="fw-bold text-white">
                    {lang[2]} ✨
                  </CardTitle>
                  <div className="fw-bold fs-7 text-white px-2 rounded-2 new-block d-flex align-items-center justify-content-center">
                    {lang[3]}
                  </div>
                </div>
                <div className="text-gray fs-7 text-white">{lang[4]}</div>
              </div>
            </Col>

            <Col
              xs={4}
              lg={5}
              className="d-flex justify-content-center align-items-center"
            >
              <CustomImgDiv className="position-relative h-100 w-100">
                <img
                  src={ArtImg}
                  className="img-fluid d-none d-lg-block position-absolute top-50 start-50 translate-middle first"
                  alt="logo-qr"
                  loading="lazy"
                  width={144}
                  height={74}
                />
                <img
                  src={Art2Img}
                  className="img-fluid d-none d-lg-block position-absolute top-50 start-50 translate-middle second"
                  alt="logo-qr"
                  loading="lazy"
                  width={144}
                  height={74}
                />
                <img
                  src={ArtImgMobile}
                  className="img-fluid d-lg-none position-absolute top-50 start-50 translate-middle first"
                  alt="logo-qr"
                  loading="lazy"
                />
                <img
                  src={Art2ImgMobile}
                  className="img-fluid d-lg-none position-absolute top-50 start-50 translate-middle second"
                  alt="logo-qr"
                  loading="lazy"
                />
              </CustomImgDiv>
            </Col>
          </Row>
        </CustomArtCard>
      </Col>
    </Row>
  );
}

export default QrMode;

const CustomArtCard = styled.div`
  background: linear-gradient(to right, #4b15b2, #a20990, #ff4e51);
  .new-block {
    background: #ffc446;
  }
`;

const CardTitle = styled.div`
  @media (min-width: 992px) {
    font-size: 18px;
  }
`;

const ArtQrLabel = styled.label`
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    background-color: #fff;
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(0);
    transition: transform 0.2s ease-in-out;
  }
  &.checked::after {
    transform: translate(-50%, -50%) scale(1);
  }
`;

const ClassicQrLabel = styled.label`
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    background-color: #9b27af;
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(0);
    transition: transform 0.2s ease-in-out;
  }
  &.checked::after {
    transform: translate(-50%, -50%) scale(1);
  }
`;

export const CustomImgDiv = styled.div`
  img {
    opacity: 0;
    animation-duration: 8s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    transition: transform 1s ease-in-out;

    &.first {
      animation-name: fadeFirst;
      z-index: 1;
    }

    &.second {
      animation-name: fadeSecond;
      z-index: 2;
    }
  }

  @keyframes fadeFirst {
    0%,
    45% {
      opacity: 1;
    }
    55% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeSecond {
    0%,
    40% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    90% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;
